import React from 'react'
import styled from 'styled-components';

const Label = ({title}) => {
  return (
    <Title>{title}</Title>
  )
}

export default Label

const Title = styled.h2`
  color: #777777 !important; /* Evita que WordPress sobrescriba el color */
  font-weight: 500 !important;
  font-size: 18px !important; 
  font-family: "Arial", sans-serif !important; 
  margin-bottom: 8px !important; 
  text-transform: uppercase;
`;